import * as React from "react"
export const Svg_046 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="m53.23 23.277-2.454 2.392 1.644 1.632h-6.698a15.822 15.822 0 0 0-3.535-8.37l4.742-4.662.01 2.297 3.458-.015-.038-8.057-8.195-.037-.016 3.399 2.337.01-4.742 4.662a16.388 16.388 0 0 0-8.515-3.475V6.468l1.66 1.617 2.433-2.414L29.501 0l-5.822 5.671 2.433 2.414 1.66-1.617v6.585a16.387 16.387 0 0 0-8.515 3.474l-4.742-4.661 2.337-.01-.016-3.399-8.196.037-.037 8.057 3.457.015.01-2.297 4.743 4.661a15.823 15.823 0 0 0-3.535 8.37H6.58l1.645-1.63-2.456-2.393L0 29l5.77 5.723 2.455-2.392-1.645-1.632h6.698c.339 3.15 1.61 6.03 3.535 8.37l-4.742 4.662-.01-2.297-3.457.015.036 8.057 8.196.037.016-3.399-2.337-.01 4.742-4.662a16.388 16.388 0 0 0 8.515 3.475v6.585l-1.66-1.617-2.433 2.414L29.5 58l5.822-5.671-2.434-2.414-1.66 1.617v-6.585a16.388 16.388 0 0 0 8.515-3.475l4.742 4.662-2.337.01.016 3.399 8.196-.037.037-8.057-3.457-.015-.01 2.297-4.742-4.661a15.823 15.823 0 0 0 3.534-8.37h6.699l-1.645 1.63 2.455 2.393L59.001 29l-5.77-5.723ZM29.5 41.638c-7.089 0-12.856-5.67-12.856-12.638 0-6.969 5.767-12.639 12.856-12.639 7.089 0 12.856 5.67 12.856 12.639 0 6.969-5.767 12.638-12.856 12.638Z"
      />
      <path
        fill="url(#c)"
        d="M29.5 35.575c3.694 0 6.688-2.944 6.688-6.575 0-3.631-2.994-6.575-6.688-6.575-3.694 0-6.688 2.944-6.688 6.575 0 3.631 2.994 6.575 6.688 6.575Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={13.644}
        x2={40.981}
        y1={8.7}
        y2={53.706}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={25.905}
        x2={32.103}
        y1={24.398}
        y2={34.601}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v58H0z" />
      </clipPath>
    </defs>
  </svg>
)